require('./angular-touch');
module.exports = 'ngTouch';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-touch/index.js
 ** module id = 659
 ** module chunks = 2
 **/